import React from 'react'
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from 'reactstrap'
import CommonCardHeader from '../../../../../Utils/CommonComponents/CommonCardHeader'
import { DefaultCheckboxTitle, Indeterminate, IndeterminateCheckbox } from '../../../../../Utils/Constants'
import { defaultCheckBoxSubTitle, defaultCheckboxData } from '../../../../../Data/Forms/FormControlsData'
import { H6 } from '../../../../../AbstractElements'

export default function DefaultCheckbox() {
    
    return (
        <Col xs={12}>
            <Card>
                <CommonCardHeader headClass='pb-0' title={DefaultCheckboxTitle} subTitle={defaultCheckBoxSubTitle} />
                <CardBody>
                    <Row className="g-3">
                        {defaultCheckboxData.map((data) => (
                            <Col sm={6} xl={4} key={data.id}>
                                <div className="card-wrapper border rounded-3 checkbox-checked">
                                    <H6 className="sub-title">{data.title}</H6>
                                    {data.child.map((item) => (
                                        <FormGroup key={item.id} className={item.groupClass ? item.groupClass : ''} check>
                                            <Input id={item.id} type="checkbox" value='' defaultChecked={item.check === 'checked'} disabled={item.disabled === 'disabled'} />
                                            <Label htmlFor={item.id} check>{item.labelText}</Label>
                                        </FormGroup>
                                    ))}
                                </div>
                            </Col>
                        ))}
                        <Col sm={6} xl={12}>
                            <div className="card-wrapper border rounded-3 checkbox-checked">
                                <H6 className="sub-title">{Indeterminate}</H6>
                                <FormGroup check>
                                    <Input id="flexCheckIndeterminate" type="checkbox" value='' />
                                    <Label htmlFor="flexCheckIndeterminate" check>{IndeterminateCheckbox}</Label>
                                </FormGroup>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </Col>
    )
}
